<template>
  <div id="app">
    <Header :navigation="navigation"/>
    <transition name="router-anim" enter-active-class="animated fadeIn">
      <router-view :key="$route.path"/>
    </transition>
    <Footer :navigation="navigation"/>
  </div>  
</template>

<script>
import Header from '@/components/nav/Header.vue';
import Footer from '@/components/nav/Footer.vue';

export default {  
  
  name: 'app',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      navigation: {
        "home" : "/",
        "about" : "/about",
        "resume" : "/resume"
      }
    }
  }
}
</script>